import { render, staticRenderFns } from "./investors.vue?vue&type=template&id=74e27fc9"
import script from "./investors.vue?vue&type=script&lang=js"
export * from "./investors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports